import type { EventPayload } from '@side/analytics';

export enum TrackPlatformFeeEvent {
  PaymentMethodAlertMount,
  PaymentMethodAlertCtaButtonClick,
  PaymentMethodAlertPageLoad,
  PaymentMethodAlertPageCloseButtonClick,
  PaymentMethodAlertPageAddMethodButtonClick,
}

type EventTypeLabels = Record<TrackPlatformFeeEvent, string>;

export const PlatformFeeEventLabels: EventTypeLabels = {
  [TrackPlatformFeeEvent.PaymentMethodAlertMount]: 'PAYMENT_METHOD',
  [TrackPlatformFeeEvent.PaymentMethodAlertCtaButtonClick]: 'PAYMENT_METHOD',
  [TrackPlatformFeeEvent.PaymentMethodAlertPageLoad]: 'PAYMENT_METHOD',
  [TrackPlatformFeeEvent.PaymentMethodAlertPageCloseButtonClick]:
    'PAYMENT_METHOD',
  [TrackPlatformFeeEvent.PaymentMethodAlertPageAddMethodButtonClick]:
    'PAYMENT_METHOD',
};

type EventTypePayloads = Record<TrackPlatformFeeEvent, EventPayload>;

enum PlatformFeeFormEventContainer {
  PaymentMethodAlert = 'payment_method_alert_banner',
  PaymentMethodAlertPage = 'payment_method_alert_page',
}

export const PlatformFeeEventsMap: EventTypePayloads = {
  [TrackPlatformFeeEvent.PaymentMethodAlertMount]: {
    eventContainer: PlatformFeeFormEventContainer.PaymentMethodAlert,
    eventTarget: 'payment_method_alert_banner',
    eventType: 'load',
    task: 'view',
  },
  [TrackPlatformFeeEvent.PaymentMethodAlertCtaButtonClick]: {
    eventContainer: PlatformFeeFormEventContainer.PaymentMethodAlert,
    eventTarget: 'add_method_button',
    eventType: 'click',
    task: 'navigate',
  },
  [TrackPlatformFeeEvent.PaymentMethodAlertPageLoad]: {
    eventContainer: PlatformFeeFormEventContainer.PaymentMethodAlertPage,
    eventTarget: 'payment_method_alert_page',
    eventType: 'load',
    task: 'view',
  },
  [TrackPlatformFeeEvent.PaymentMethodAlertPageCloseButtonClick]: {
    eventContainer: PlatformFeeFormEventContainer.PaymentMethodAlertPage,
    eventTarget: 'close_button',
    eventType: 'click',
    task: 'exit',
  },
  [TrackPlatformFeeEvent.PaymentMethodAlertPageAddMethodButtonClick]: {
    eventContainer: PlatformFeeFormEventContainer.PaymentMethodAlertPage,
    eventTarget: 'add_method_button',
    eventType: 'click',
    task: 'navigate',
  },
};
